import { Box, Card, TagColor as Color, Tag, Text } from '@factorialco/deprecated-design-system'
import { Variants } from 'framer-motion'

import {
  statusTranslation,
  translatedIncidenceName,
} from 'modules/bookkeepers/lib/dynamicTranslations'
import tagColor from 'modules/bookkeepers/lib/tagColor'
import { INHOUSE_INCIDENCE_STATUSES } from 'modules/payroll_bundle/lib/Incidences/Status'

interface AnimatedRowProps {
  name: string
  type: string
  status: string
  color: Color
}

const AnimatedRow: React.FC<AnimatedRowProps> = ({ name, type, status, color }) => {
  const itemVariants: Variants = {
    hidden: { y: 200, opacity: 0 },
    visible: { y: -24, opacity: 1 },
  }

  return (
    <Box.Motion variants={itemVariants} boxShadow="s100" borderRadius={{ all: 'abs016' }}>
      <Card>
        <Card.Content>
          <Box flexDirection="row" justifyContent="spaceBetween" width="full">
            <Box flexGrow width="s80">
              <Text weight="bold" size="200">
                {name}
              </Text>
            </Box>
            <Box flexGrow width="s80" textAlign="left" justifyContent="flexStart">
              {type}
            </Box>
            <Box>
              <Tag size="normal" type={color}>
                {status}
              </Tag>
            </Box>
          </Box>
        </Card.Content>
      </Card>
    </Box.Motion>
  )
}

const LandingAnimation = () => {
  const containerVariants: Variants = {
    visible: {
      transition: {
        staggerChildren: 1,
      },
    },
  }

  return (
    <Box.Motion
      variants={containerVariants}
      background="grey200"
      borderRadius={{ all: 'abs016' }}
      paddingX="s24"
      gap="s12"
      width="full"
      style={{ maxWidth: '80%' }}
      initial="hidden"
      animate="visible"
    >
      <AnimatedRow
        name="Bailey Harris"
        type={translatedIncidenceName('contract')}
        status={statusTranslation(INHOUSE_INCIDENCE_STATUSES.to_do, false, true)}
        color={tagColor(INHOUSE_INCIDENCE_STATUSES.to_do, false, true)}
      />
      <AnimatedRow
        name="Erik Winter"
        type={translatedIncidenceName('hiring')}
        status={statusTranslation(INHOUSE_INCIDENCE_STATUSES.doing, false, true)}
        color={tagColor(INHOUSE_INCIDENCE_STATUSES.doing, false, true)}
      />
      <AnimatedRow
        name="John Smith"
        type={translatedIncidenceName('termination')}
        status={statusTranslation(INHOUSE_INCIDENCE_STATUSES.done, false, true)}
        color={tagColor(INHOUSE_INCIDENCE_STATUSES.done, false, true)}
      />
    </Box.Motion>
  )
}

export default LandingAnimation
